import { Button } from "@ui/Button";

export const WatchFullVideoButton = (props: { videoUrl: string }) => {
	return (
		<Button
			symbol="play_circle"
			variant="primary"
			style={{ width: "100%" }}
			onClick={() => {
				window.open(props.videoUrl, "_blank");
			}}
		>
			Watch full video
		</Button>
	);
};
